import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import AdminDashboard from './pages/adminConsole/admin';
import CustomerOrderList from './pages/adminConsole/CustomerOrderList';
import NewCoupon from './pages/adminConsole/newCoupon';
import NewReward from './pages/adminConsole/newReward';
import UserList from './pages/adminConsole/UserList';
import GuestOrders from './pages/adminConsole/GuestOrders';
import ProductManagement from './pages/adminConsole/ProductManagement';
import AdminManagement from './pages/adminConsole/AdminManagement';
import AdminLogin from './pages/adminConsole/security/AdminLogin';
import AdminAuthAction from './pages/adminConsole/security/AdminAuthAction';
import AllOrders from './pages/adminConsole/AllOrders';
import ReportPage from './pages/adminConsole/ReportPage';
import StatistikkPage from './pages/adminConsole/StatistikkPage';
import KlippekortOversikt from './pages/adminConsole/KlippekortOversikt';
import RabattkodeManagement from './pages/adminConsole/RabattkodeManagement';
import PrintPage from './pages/adminConsole/PrintPage';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function AppRoutes() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Check for redirect path from 404.html
    const redirectPath = sessionStorage.getItem('redirectPath');
    if (redirectPath && redirectPath !== '/') {
      sessionStorage.removeItem('redirectPath');
      navigate(redirectPath, { replace: true });
    }
  }, [navigate]);

  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/auth-action" element={<AdminAuthAction />} />
      <Route path="/" element={
        <ProtectedRoute>
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/customer-orders/:userId" element={
        <ProtectedRoute>
          <CustomerOrderList />
        </ProtectedRoute>
      } />
      <Route path="/new-coupon" element={
        <ProtectedRoute>
          <NewCoupon />
        </ProtectedRoute>
      } />
      <Route path="/new-reward" element={
        <ProtectedRoute>
          <NewReward />
        </ProtectedRoute>
      } />
      <Route path="/user-list" element={
        <ProtectedRoute>
          <UserList />
        </ProtectedRoute>
      } />
      <Route path="/guest-orders" element={
        <ProtectedRoute>
          <GuestOrders />
        </ProtectedRoute>
      } />
      <Route path="/product-management" element={
        <ProtectedRoute>
          <ProductManagement />
        </ProtectedRoute>
      } />
      <Route path="/all-orders" element={
        <ProtectedRoute>
          <AllOrders />
        </ProtectedRoute>
      } />
      <Route path="/report" element={
        <ProtectedRoute>
          <ReportPage />
        </ProtectedRoute>
      } />
      <Route path="/statistikk" element={
        <ProtectedRoute>
          <StatistikkPage />
        </ProtectedRoute>
      } />
      <Route path="/admin-management" element={
        <ProtectedRoute>
          <AdminManagement />
        </ProtectedRoute>
      } />
      <Route path="/klippekort-oversikt" element={
        <ProtectedRoute>
          <KlippekortOversikt />
        </ProtectedRoute>
      } />
      <Route path="/rabattkoder" element={
        <ProtectedRoute>
          <RabattkodeManagement />
        </ProtectedRoute>
      } />
      {/* Deliberately NOT wrapped in ProtectedRoute - interim print-station
          stopgap while the kiosk touchscreen is on its way, meant to have
          "full and easy access", no login required. */}
      <Route path="/print" element={<PrintPage />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
